module.exports = __webpack_public_path__ + "static/media/999827.d2c72f59.png";